module.exports = __webpack_public_path__ + "static/media/tarieven.573318ad.jpg";